var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3036 9.09082C27.7107 9.09082 9.39453 27.4069 9.39453 49.9999C9.39453 72.5929 27.7107 90.909 50.3036 90.909C72.8966 90.909 91.2127 72.5929 91.2127 49.9999C91.2127 27.4069 72.8966 9.09082 50.3036 9.09082ZM74.0228 55.5486H58.634C57.0999 55.5486 55.8523 56.7963 55.8523 58.3303V73.7191H44.75V58.3303C44.75 56.7963 43.5024 55.5486 41.9684 55.5486H26.5795V44.4463H41.9684C43.5024 44.4463 44.75 43.1987 44.75 41.6647V26.2758H55.8523V41.6647C55.8523 43.1987 57.0951 44.4463 58.634 44.4463H74.0228V55.5486Z",
    fill: "#6BE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9705 55.5486H26.5816V44.4463C12.1443 44.4463 11.1055 61.7284 11.1055 61.7284C19.5621 88.3069 44.757 90.5303 44.757 90.5303V58.3303C44.757 56.7962 43.5094 55.5486 41.9754 55.5486H41.9705Z",
    fill: "url(#paint0_linear_590_18260)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9676 44.4465C43.5017 44.4465 44.7493 43.1989 44.7493 41.6649V26.276H55.8516C55.8516 11.8387 38.5695 10.7998 38.5695 10.7998C11.9909 19.2564 9.76758 44.4514 9.76758 44.4514H41.9676V44.4465Z",
    fill: "url(#paint1_linear_590_18260)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8525 9.46484V26.2761V41.6649C55.8525 43.199 57.0953 44.4466 58.6341 44.4466H74.023V55.5489C88.4604 55.5489 89.4993 38.2668 89.4993 38.2668C81.0427 11.6882 55.8477 9.46484 55.8477 9.46484H55.8525Z",
    fill: "url(#paint2_linear_590_18260)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0228 55.5488H58.6339C57.0999 55.5488 55.8523 56.7964 55.8523 58.3305V73.7193H44.75C44.75 88.1566 62.0321 89.1955 62.0321 89.1955C88.6106 80.7389 90.834 55.5439 90.834 55.5439H74.0228V55.5488Z",
    fill: "url(#paint3_linear_590_18260)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_590_18260",
    x1: 27.9312,
    y1: 44.4463,
    x2: 27.9312,
    y2: 90.5303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_590_18260",
    x1: 55.8516,
    y1: 27.6207,
    x2: 9.76758,
    y2: 27.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_590_18260",
    x1: 72.6783,
    y1: 55.5489,
    x2: 72.6783,
    y2: 9.46484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_590_18260",
    x1: 44.75,
    y1: 72.3746,
    x2: 90.834,
    y2: 72.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.08cd00c2386b3150eb5727397a5b31c0.svg";
export { ForwardRef as ReactComponent };